export default __webpack_public_path__ + "static/media/property_94.cd8cf768.png";